class TimerActivityManager {
    constructor() {
        this.isTabVisible = true
        this.isUserActive = true
        this.lastActivityTime = Date.now()
        this.inactivityTimeout = 30 * 1000 // 30 segundos
        this.timers = new Map()
        this.listeners = []
        
        this.setupEventListeners()
        this.startInactivityCheck()
    }

    setupEventListeners() {
        document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this))
        
        const activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click']
        activityEvents.forEach(event => {
            document.addEventListener(event, this.handleUserActivity.bind(this), true)
        })

        window.addEventListener('focus', this.handleWindowFocus.bind(this))
        window.addEventListener('blur', this.handleWindowBlur.bind(this))
    }

    handleVisibilityChange() {
        this.isTabVisible = !document.hidden
        this.updateTimersState()
        this.notifyListeners()
    }

    handleUserActivity() {
        this.lastActivityTime = Date.now()
        if (!this.isUserActive) {
            this.isUserActive = true
            this.updateTimersState()
            this.notifyListeners()
        }
    }

    handleWindowFocus() {
        this.isTabVisible = true
        this.handleUserActivity()
    }

    handleWindowBlur() {
        this.isTabVisible = false
        this.updateTimersState()
        this.notifyListeners()
    }

    startInactivityCheck() {
        setInterval(() => {
            const now = Date.now()
            const timeSinceLastActivity = now - this.lastActivityTime
            
            if (timeSinceLastActivity > this.inactivityTimeout && this.isUserActive) {
                this.isUserActive = false
                this.updateTimersState()
                this.notifyListeners()
            }
        }, 30000) // Verifica a cada 30 segundos
    }

    shouldTimersRun() {
        return this.isTabVisible && this.isUserActive
    }

    registerTimer(componentId, timerName, timerInstance, managedByActivityManager = true) {
        const key = `${componentId}_${timerName}`
        this.timers.set(key, {
            instance: timerInstance,
            componentId,
            timerName,
            isRunning: true,
            managedByActivityManager
        })
    }

    unregisterTimer(componentId, timerName) {
        const key = `${componentId}_${timerName}`
        this.timers.delete(key)
    }

    updateTimersState() {
        const shouldRun = this.shouldTimersRun()
        
        this.timers.forEach((timer) => {
            if (!timer.managedByActivityManager) {
                return
            }
            if (shouldRun && !timer.isRunning) {
                timer.instance.start()
                timer.isRunning = true
            } else if (!shouldRun && timer.isRunning) {
                timer.instance.stop()
                timer.isRunning = false
            }
        })
    }

    addListener(callback) {
        this.listeners.push(callback)
    }

    removeListener(callback) {
        const index = this.listeners.indexOf(callback)
        if (index > -1) {
            this.listeners.splice(index, 1)
        }
    }

    notifyListeners() {
        const state = {
            isTabVisible: this.isTabVisible,
            isUserActive: this.isUserActive,
            shouldTimersRun: this.shouldTimersRun()
        }
        
        this.listeners.forEach(callback => {
            try {
                callback(state)
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('[TimerActivityManager] Erro ao notificar listener:', error)
            }
        })
    }

    getState() {
        return {
            isTabVisible: this.isTabVisible,
            isUserActive: this.isUserActive,
            shouldTimersRun: this.shouldTimersRun(),
            lastActivityTime: this.lastActivityTime,
            timersCount: this.timers.size
        }
    }

    destroy() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this))
        
        const activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click']
        activityEvents.forEach(event => {
            document.removeEventListener(event, this.handleUserActivity.bind(this), true)
        })

        window.removeEventListener('focus', this.handleWindowFocus.bind(this))
        window.removeEventListener('blur', this.handleWindowBlur.bind(this))
        
        this.timers.clear()
        this.listeners = []
    }
}

export default new TimerActivityManager()